// Counts onsite (non–community-hub) customers for a distribution location for the
// upcoming pickup week, mirroring CalculateCommunityLocationStatus for hubs.
import NextPickupDay from "./NextPickupDay.js";
import firebase from "../components/Firebase.js";

function isOnsiteOrder(orderData) {
  const cp = orderData.communityPickup;
  if (cp === undefined || cp === null) {
    return true;
  }
  if (Array.isArray(cp) && cp.length === 0) {
    return true;
  }
  return false;
}

export default async function CalculateDistributionSiteStatus(
  pickupLocation,
  setCurrentStatus,
  userInfo,
) {
  const locationKey = pickupLocation.name;
  const distributionDate = NextPickupDay(pickupLocation.pickupDay);

  const database = firebase.firestore();
  const communityOrdersCollectionRef = database
    .collection("DistributionLocations")
    .doc(locationKey)
    .collection("CommunityOrders");

  try {
    const querySnapshot = await communityOrdersCollectionRef
      .where("distributionDate", "==", distributionDate)
      .get();

    const combinedOrders = {};
    let userParticipating = false;
    const listOfUsers = [];

    querySnapshot.forEach((doc) => {
      const orders = doc.data();
      Object.keys(orders).forEach((order) => {
        if (order !== "distributionDate" && order !== "orderCount") {
          combinedOrders[order] = orders[order];
        }
      });
    });

    Object.keys(combinedOrders).forEach((orderKey) => {
      const row = combinedOrders[orderKey];
      if (!isOnsiteOrder(row)) {
        return;
      }
      const userId = orderKey.split("-")[2];
      if (userInfo.userId === userId) {
        userParticipating = true;
      }
      if (!listOfUsers.includes(userId)) {
        listOfUsers.push(userId);
      }
    });

    setCurrentStatus([
      listOfUsers,
      parseInt(listOfUsers.length, 10),
      userParticipating,
    ]);
  } catch (error) {
    console.error("Error fetching distribution site orders:", error);
  }
}
